import { render } from "./TransitionPic.vue?vue&type=template&id=72508db1&scoped=true&ts=true"
import script from "./TransitionPic.vue?vue&type=script&lang=ts"
export * from "./TransitionPic.vue?vue&type=script&lang=ts"

import "./TransitionPic.vue?vue&type=style&index=0&id=72508db1&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72508db1"]])

export default __exports__